module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_1@2x.b369533c.png";